import { ReactNode, forwardRef } from "react";
import FloatingLabelBase from "../FloatingLabelBase/FloatingLabelBase";
import { default as VFCalender } from "@vfuk/core-calendar-picker";
import type { CalendarPickerProps as VFCalenderProps } from "@vfuk/core-calendar-picker/dist/CalendarPicker.types";
import FloatingLabelCalenderStyles, {
  FloatingLabelCalenderStylesProps,
} from "./FloatingLabelCalenderStyles";

type CalenderProps = {
  label: string;
  error?: string;
  tooltipError?: ReactNode;
  spaceForError?: boolean;
  onInvalidInputEntry?: (errors: string[]) => void;
} & Omit<VFCalenderProps, "onInvalidInputEntry"> &
  FloatingLabelCalenderStylesProps;

export const FloatingLabelCalender = forwardRef<
  typeof VFCalender,
  CalenderProps
>(
  ({
    label,
    error,
    isTextHidden,
    onInvalidInputEntry = () => {
      return;
    },
    ...inputProps
  }: CalenderProps) => {
    return (
      <FloatingLabelCalenderStyles
        id={inputProps.id}
        isTextHidden={isTextHidden}
      >
        <FloatingLabelBase
          forceFloat={!!inputProps.value}
          label={label}
          error={error}
          {...inputProps}
        >
          <VFCalender
            {...inputProps}
            onInvalidInputEntry={onInvalidInputEntry}
          />
        </FloatingLabelBase>
      </FloatingLabelCalenderStyles>
    );
  }
);

FloatingLabelCalender.displayName = "FloatingLabelCalender";
